<template>
  <div v-if="visible" class="modal-overlay modal-anexar-arquivos">
    <div class="duplicar-exame-dialog">
      <div>
        <div class="modal-header">
          <span class="modal-title">{{ $t('x_plus.attach') }}</span>
        </div>
        <!-- Lista de exames/exames anexados -->
        <label class="label-modal">{{ $t('x_plus.attachments') }}</label>
        <div v-if="savedFiles && savedFiles.length" class="lista-exames-salvos">
          <ul>
            <li v-for="file in savedFiles" :key="file.dicomPlusFileID" class="item-exame-salvo">
              <span>{{ getTipoAnexoLabel(file.tipoAnexo) }}</span>
               <a
                target="_blank"
                rel="noopener"
                class="anexo-link"
                style="cursor: pointer;"
                @click="$emit('request-download-link', file.dicomPlusFileID)">
                {{file.fileName }}
              </a>
              <md-button class="btn-remover-anexo" @click="$emit('delete', file.dicomPlusFileID)"> ❌ </md-button>
            </li>
          </ul>
        </div>
        <div v-else class="empty-attachments-box">
          <div class="placeholder-anexos-vazio">{{ $t('x_plus.no_attachments_saved') }}</div>
        </div>
        <!-- Anexar arquivos -->
        <div class="duplicar-exame-list">
          <div class="duplicar-exame-list-scroll">
            <label class="label-modal">{{ $t('x_plus.new_attachment') }}</label>
            <div v-if="files.length" class="lista-anexos">
              <div v-for="(anexo, idx) in files" :key="anexo.name" class="item-anexo">
                <span class="anexo-nome">{{ anexo.name }}</span>
                <select v-model="anexo.tipoAnexo" class="form-control attachment-type-select">
                  <template v-for="(anexoTipo, indice) in anexoTipoOptions">
                    <option
                      v-if="indice === separadorIndex"
                      :key="`separador-${indice}`"
                      class="option-separador"
                      disabled
                    >──────────</option>
                    <option :key="anexoTipo.value" :value="anexoTipo.value">
                      {{ anexoTipo.label }}
                    </option>
                  </template>
                </select>
                <md-button class="btn-remover-anexo" @click="removeFile(idx)"> ❌ </md-button>
              </div>
            </div>
            <div v-else class="empty-attachments-box empty-selected-attachments-box">
              <div class="placeholder-anexos-vazio">{{ $t('x_plus.no_attachments_selected') }}</div>

            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer duplicar-exame-footer">
        <input ref="fileInput" type="file" multiple :accept="accept" style="display: none" @change="onFileChange" />
        <md-button v-tooltip="{ content: $t('x_plus.search_attachment') }" class="btn-anexar-arquivos" :disabled="status !== 0" @click="triggerFileInput" >
          <span class="material-icons">search</span>
        </md-button>
        <md-button class="md-raised" @click="emitClose">{{ $t('close') }}</md-button>
        <md-button v-tooltip="{ content: $t('x_plus.attach_file') }" style="color: #fff" class="btn-anexar-arquivos" :disabled="isSaveDisabled" @click="emitSave">{{
          $t('x_plus.attach')
        }}</md-button>
      </div>
    </div>
  </div>
</template>

<script>
  import SparkMD5 from 'spark-md5';
  import CONSTANTS from '@/shared/constants/constants';
  import { showDialog } from '@/shared/sweetAlerts/showDialog';
  export default {
    name: 'AnexarArquivosModal',
    props: {
      visible: { type: Boolean, required: true },
      anexoTipoOptions: { type: Array, required: true },
      duplicacoes: { type: Array, default: () => [] },
      accept: { type: String, default: '.pdf,.jpg,.jpeg' },
      savedFiles: { type: Array, default: () => [] },
      status: { type: Number, default: 0 }
    },
    data() {
      return {
        files: []
      }
    },
    computed: {
      isSaveDisabled() {
        if (!this.files || !this.files.length) return true
        return this.files.some(file => !file.tipoAnexo)
      },
      // Índice antes do qual entra o separador: só existe quando Pedido médico
      // está no topo da lista e há outros tipos depois dele.
      separadorIndex() {
        const indicePedidoMedico = this.anexoTipoOptions
          .findIndex(tipo => tipo.value === CONSTANTS.DICOM_PLUS_TIPO_ANEXO.PEDIDO_MEDICO)
        return indicePedidoMedico === 0 && this.anexoTipoOptions.length > 1 ? 1 : -1
      }
    },
    methods: {
      getTipoAnexoLabel(tipoAnexo) {
        const found = this.anexoTipoOptions.find((opt) => opt.value === tipoAnexo)
        return found ? found.label : tipoAnexo
      },
      triggerFileInput() {
        this.$refs.fileInput.click()
      },
      async onFileChange(e) {
        const arquivos = Array.from(e.target.files)
        for (const arq of arquivos) {
          const isPDF = arq.type === 'application/pdf' && arq.name.toLowerCase().endsWith('.pdf');
          const isJPG = arq.type === 'image/jpeg' && (arq.name.toLowerCase().endsWith('.jpg') || arq.name.toLowerCase().endsWith('.jpeg'));
          if (!isPDF && !isJPG) {
            showDialog({
              icon: 'warning',
              title: 'Extensão inválida',
              text: `Somente arquivos PDF ou JPG são permitidos.`,
              confirmButtonText: 'OK'
            })
            continue;
          }

          const md5 = await this.getFileMD5(arq);
          const duplicado = this.files.some(a => a.md5 === md5);
          if (duplicado) {
            showDialog({
              icon: 'warning',
              title: 'Arquivo repetido',
              text: `Não é permitido selecionar arquivos repetidos`,
              confirmButtonText: 'OK'
            })
            continue
          }
          const fileData = {
            name: arq.name,
            size: arq.size,
            type: arq.type,
            lastModified: arq.lastModified,
            tipoAnexo: '',
            md5
          }
          if (isJPG) {
            const reader = new FileReader()
            reader.onload = (evt) => {
              this.files.push({
                ...fileData,
                preview: evt.target.result,
                file: arq
              })
            }
            reader.readAsDataURL(arq)
          } else if (isPDF) {
            // PDF não tem preview de imagem
            this.files.push({
              ...fileData,
              file: arq
            })
          }
        }
        e.target.value = ''
      },
      getFileMD5(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const md5 = SparkMD5.ArrayBuffer.hash(e.target.result);
            resolve(md5);
          }
          reader.onerror = reject;
          reader.readAsArrayBuffer(file);
        });
      },
      removeFile(idx) {
        this.files.splice(idx, 1)
      },
      emitSave() {
        this.$emit('save', { files: this.files })
      },
      emitClose() {
        this.$emit('close')
        this.files = []
      },
      clearImportedFiles() {
        this.files = []
      }
    },

  }
</script>
<style scoped>
  .modal-anexar-arquivos {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .duplicar-exame-dialog {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 6px 32px rgba(0, 0, 0, 0.22);
    min-width: 320px;
    min-height: 45vh;
    width: 50vw;
    padding: 32px 30px 20px 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    gap: 22px;
    position: relative;
    max-height: 90vh;
    width: 60vw;
  }

  .modal-header {
    font-size: 20px;
    font-weight: 700;
    color: #424242;
    text-align: center;
    margin-bottom: 8px;
  }

  .form-row {
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .label-modal {
    font-size: 16px;
    color: #444;
    font-weight: 600;
  }

  .form-control {
    border: 1px solid #e1e6ed;
    border-radius: 6px;
    padding: 7px 12px;
    font-size: 16px;
    background: #fff;
    outline: none;
    width: 100%;
  }

  .attachment-type-select {
    margin-right: 10px;
    width: 180px;
  }

  .option-separador {
    color: #bdbdbd;
    background-color: #f8f9fb;
  }

  .empty-attachments-box {
    background-color: #f8f9fb;
    border-radius: 15px;
    margin: 15px 0;
    width: 100%;
  }

  .empty-selected-attachments-box {
    margin-top: 12px;
  }

  .modal-footer,
  .duplicar-exame-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 18px;
  }

   .btn-primary,
  .btn-anexar-arquivos,
  .md-raised {
    min-width: 88px;
    height: 36px;
    margin: 6px 8px;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
  }

  .btn-anexar-arquivos {
    background-color: #28863A;
  }

  .btn-anexar-arquivos .material-icons {
    color: #fff !important;
    font-size: 1.5rem;
  }
  .btn-primary {
    background: #6180e4;
    color: #fff;
  }

  .md-raised {
    background: #f4f6fa;
    color: #424242;
  }

  .btn-primary:disabled {
    background: #b4bbe3;
    color: #fff;
    cursor: not-allowed;
  }
  .btn-anexar-arquivos:disabled,
.btn-anexar-arquivos[disabled] {
  background: #e0e0e0;
  color: #aaa;
  cursor: not-allowed;
  border: 1px solid #ccc;
  opacity: 0.8;
}

  @media (max-width: 600px) {
    .duplicar-exame-dialog {
      max-width: 95vw;
      padding: 18px 10px 10px 10px;
    }
  }
  .lista-anexos {
    max-height: 250px; /* Ajuste conforme seu modal */
    overflow-y: auto;
    padding-right: 8px;
    border-radius: 10px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 7px;
  }

  .item-anexo {
    display: flex;
    align-items: center;
    background: #f8f9fb;
    border-radius: 6px;
    padding: 7px 10px;
    gap: 10px;
    max-height: 60px;
  }

  .anexo-icon-pdf {
    font-size: 18px;
    color: #c73b51;
    flex-shrink: 0;
  }

  .anexo-nome {
    flex: 1;
    font-size: 15px;
    color: black;
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 6px;
  }

  .btn-remover-anexo {
    background: none;
    color: #e91e63;
    font-size: 18px;
    border: none;
    cursor: pointer;
    min-width: unset;
    padding: 2px 8px;
    transition: background 0.15s;
    align-self: center;
  }

  .btn-remover-anexo:hover {
    background: #fce4ec;
  }
  .lista-exames-salvos {
    background: #f8f9fb;
    border-radius: 11px;
    padding: 12px 6px;
    overflow: auto;
    max-height: 20vh;
    margin-bottom: 20px;
  }

  .lista-exames-salvos h4 {
    font-size: 16px;
    font-weight: 700;
    color: #424242;
  }

  .lista-exames-salvos ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .item-exame-salvo {
    display: flex;
    align-items: center;
    background: #f8f9fb;
    border-radius: 6px;
    padding: 2px 10px;
  }

  .anexo-link {
    display: inline-block;
    max-width: 360px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  .item-exame-salvo:last-child {
    border-bottom: none;
  }

  .item-exame-salvo span {
    color: #485064;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.1px;
    flex: 1;
    padding-left: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .btn-excluir-exame {
    background: #d5394e;
    border: none;
    border-radius: 5px;
    padding: 5px 18px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(213, 57, 78, 0.08);
    transition:
      background 0.15s,
      box-shadow 0.15s;
  }

  .btn-excluir-exame:hover {
    background: #b92a3b;
    box-shadow: 0 2px 8px rgba(213, 57, 78, 0.12);
  }
  .placeholder-anexos-vazio {
  color: #999;
  text-align: center;
  font-size: 15px;
  padding: 16px 0;
}

  @media (max-width: 720px) {
    .modal-anexar-arquivos {
      align-items: stretch;
      padding: 0;
    }

    .duplicar-exame-dialog {
      border-radius: 0;
      gap: 14px;
      height: 100dvh;
      max-height: 100dvh;
      max-width: none;
      min-height: 0;
      min-width: 0;
      overflow: hidden;
      padding: 18px 12px 12px;
      width: 100vw;
    }

    .duplicar-exame-dialog > div:first-child {
      flex: 1 1 auto;
      min-height: 0;
      overflow-y: auto;
      overflow-x: hidden;
      padding-bottom: 8px;
    }

    .modal-header {
      margin-bottom: 14px;
      padding-left: 18px;
      text-align: left;
    }

    .modal-title {
      font-size: 1rem;
      line-height: 1.35;
    }

    .lista-exames-salvos {
      max-height: 28dvh;
      overflow-x: hidden;
      padding: 8px;
    }

    .item-exame-salvo {
      display: grid;
      grid-template-columns: minmax(72px, 0.34fr) minmax(0, 1fr) 36px;
      gap: 8px;
      min-width: 0;
      padding: 8px;
    }

    .item-exame-salvo span,
    .anexo-link {
      max-width: none;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .lista-anexos {
      max-height: 32dvh;
      overflow-x: hidden;
      padding-right: 0;
    }

    .item-anexo {
      display: grid;
      grid-template-columns: minmax(0, 1fr) 36px;
      gap: 8px;
      max-height: none;
      padding: 10px;
    }

    .item-anexo .anexo-nome {
      margin-right: 0;
      min-width: 0;
    }

    .attachment-type-select {
      grid-column: 1 / -1;
      margin-right: 0;
      width: 100%;
    }

    .btn-remover-anexo {
      justify-self: center;
      margin: 0;
      padding: 0;
      width: 34px;
    }

    .modal-footer,
    .duplicar-exame-footer {
      display: grid;
      flex-shrink: 0;
      gap: 8px;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      margin-top: 0;
    }

    .duplicar-exame-footer .btn-anexar-arquivos:last-child {
      grid-column: 1 / -1;
    }

    .btn-anexar-arquivos,
    .md-raised {
      margin: 0 !important;
      min-width: 0;
      width: 100%;
    }
  }
</style>
